import Grid from '@mui/material/Grid';
import * as React from 'react';
import { ResponsiveContainer } from 'recharts';


/*
*   Компонент - обертка для графиков. В основном служит для нормальной мобильной адаптиции
*   По умолчанию, при использовании компонента ResponsiveContainer - график не отрисовывался, + при сжатии браузера, график не пересчитывался.
*   https://github.com/recharts/recharts/issues/854
*/


export type IChartCustom = {
    children: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
    height?: number | string,
}


export function ChartCustom({
    children,
    height = 300,
}: IChartCustom) {

    return (
        <Grid sx={{
            position: 'relative',
            height: height,
        }}>
            <Grid sx={{
                position: 'absolute',
                top: '8px',
                left: '0',
                width: '100%',
                height: '100%',
                fontSize: '14px',
            }}>
                <ResponsiveContainer width='100%' height='100%' >
                    {children}
                </ResponsiveContainer>
            </Grid>
        </Grid>
    );
}